import React, { useEffect } from 'react';
import { useApptekster } from '../contexts/ApptekstContext';
import { SVVInformationMessage } from '@komponentkassen/svv-information-message';

export const TekniskFeil: React.FC = () => {
    const t = useApptekster();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="svv-container--hovedinnhold">
            <SVVInformationMessage type="error">
                {t('personlig-kjennemerke.delt.teknisk-feil')}
            </SVVInformationMessage>
        </div>
    );
};
